import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, catchError, switchMap, tap } from 'rxjs';
import { logoutUser, logoutUserWithoutRedirecting } from '../actions/auth.actions';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class LogoutEffect {
  private actions = inject(Actions);
  private authSrv = inject(AuthService);
  private router = inject(Router);


  onLogoutRedirectUserToSignin$ = createEffect(
    () =>
      { return this.actions.pipe(
        ofType(logoutUser),
        tap(() => this.router.navigate(['signin']))
      ) },
    { dispatch: false }
  );
}